/*  DogBox cage builder - PRICE LIST (all money values in GBP, sizes in mm)
    Only edit the numbers between EDIT BELOW / EDIT ABOVE.
    Format: name = number.  Blank = 0.  Text after // is just a note.
    Do not change the very first and last lines.                        */
window.CAGE_PRICES = `
/* ---- EDIT BELOW ---- */

/* Prices */
base_price     = 0       // fixed starting cost of any cage, on top of the surface rate
surface_rate   = 125     // GBP per square metre of outer surface
extra_door     = 60      // per door beyond the first
partition      = 45      // per internal partition
weatherproof   = 60      // solid weatherproof panels (yes/no)
escape_large   = 20      // one large escape door across the whole rear (flat)
escape_each    = 20      // per rear escape door (twin doors = 2, individual = one per compartment)
top_tray       = 30      // top storage tray, before matting
mat_rate       = 28      // GBP per square metre of coin matting on the tray (width x depth)
cad_rate       = 50      // GBP per hour of CAD design time (charged on every bespoke cage)
cad_hours      = 4       // hours of CAD time charged on every build
ral_cage       = 40      // custom RAL colour for the cage body (added when a colour is chosen)
ral_door       = 40      // custom RAL colour for the doors (added when a colour is chosen)
strengthen     = 120     // extra bracing when the cage is wider or deeper than strengthen_over
round_to       = 5       // round the estimate to the nearest GBP (0 = to nearest 1)

/* Size limits (millimetres) and starting sizes */
min_w = 400    max_w = 1400   def_w = 900
min_h = 400    max_h = 1200   def_h = 700
min_d = 400    max_d = 1400   def_d = 600
step  = 5

/* Build rules (millimetres) */
max_door_w      = 650    // widest a single door can be
min_door_w      = 350    // narrowest a door can be
strengthen_over = 1010   // width or depth above this adds the strengthening cost and needs an escape door
twin_escape_w   = 1010   // cages this wide or wider need twin or individual escape doors (one large door is too weak)

/* ---- EDIT ABOVE ---- */
`;
